<div class="header">
    <h1 class="header__title">
        {{ currentPage | slptTranslate }}
    </h1>
</div>
